module.exports = __webpack_public_path__ + "static/media/adaptive_plan.6e8f56f4.webp";